const getters = {
  device: state => state.app.device,
  collapsed: state => state.app.collapsed,
  theme: state => state.app.theme,
  firstLogin: state => state.app.firstLogin,
  microAppLoading: state => state.app.microAppLoading,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  avatarBg: state => state.user.avatarBg,
  nickname: state => state.user.name,
  roleTag: state => state.user.roleTag,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  userId: state => state.user.userId,
  areaCode: state => state.user.areaCode,
  mobile: state => state.user.mobile,
  newMobile: state => state.user.newMobile,
  accountCode: state => state.user.accountCode,
  accountStatus: state => state.user.accountStatus,
  defaultPwdFlag: state => state.user.defaultPwdFlag,
  userList: state => state.user.userList,
  systemList: state => state.user.systemList,
  windowTabs: state => state.user.windowTabs,
  tryoutUser: state => state.user.tryoutUser,
  accountProxy: state => state.user.accountProxy,
  tenantFullName: state => state.user.tenantFullName,
  isTenantAdmin: state => state.user.isTenantAdmin,
  proxyList: state => state.user.proxyList,
  proxyUserId: state => state.user.proxyUserId,
  proxyUserName: state => state.user.proxyUserName,
  addRouters: state => state.permission.addRouters,
  routeList: state => state.permission.routeList,
  mainTabs: state => {
    const { tabs } = state.tabs
    // const regx = new RegExp(`^\\/${currentAppKey}((\\/\\w+)+)`)
    // TODO 暂时解决多应用保留路径的问题，后期再改
    const regx = /^\/[\w-]+((\/[\w-]+)+)/
    return tabs.map(item => {
      return regx.exec(item?.path)?.[1]
    })
  },
  mainFullTabs: state => state.tabs.tabs,
  subApp: state => state.app.subApp,
  tabs: state => state.tabs.tabs,
  microApps: state => state.tabs.microApps,
  showMicroApp: state => state.tabs.showMicroApp,
  currentMicroApp: state => {
    const { microApps, showMicroApp } = state.tabs
    const currentApp = microApps?.[showMicroApp]
    return currentApp?.app || {}
  },
  currentAppTabs: state => {
    const { showMicroApp, microApps } = state.tabs
    const currentApp = microApps?.[showMicroApp]
    return currentApp?.children
  },
  // 这块返回的 keep 路由名没有任何筛选条件
  // 如果只是想做部分页面缓存，可以获取 currentAppTabs 去自己处理
  currentAppKeeps: (state, getters) => {
    const { currentAppTabs } = getters
    return currentAppTabs?.map(tab => tab.name)
  },
  // 总账的默认设置数据
  default_account_book: state => state.user.default_account_book,
  // 资产的默认设置数据
  default_company: state => state.user.default_company,
  showRobotIcon: state => state.tabs.showRobotIcon,
  hasAgent: state => state.tabs.hasAgent
}

export default getters
